import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

// Order matters: the lifted design system first, then the additions this app
// needs on top of it. See src/styles/app.css.
// Load order is the cascade, so it is the contract.
//
// styles.css is the design system the shell, login and CLI approval screens are
// built on. dashboard.css is the benchmark dashboard's own sheet and redefines
// the palette on :root, so it comes second and wins — the dashboard is the
// product's main screen and its design is the one the app follows. app.css is
// last and holds only what this application needs that neither prototype sheet
// has: loading states, error states, and the onboarding surface, none of which
// a static click-through had to render.
//
// trace.css is gone with the trace view it styled. The `detail` column that
// would feed that view accumulates from every upload, so the screen is a UI
// change when it comes back — but 929 lines of CSS for a screen that does not
// exist is 929 lines shipped to every visitor.
import "./styles/styles.css";
import "./styles/dashboard.css";
import "./styles/app.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("index.html is missing #root");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
